/* eslint-disable no-console */
import store from "./store";

import { register } from "register-service-worker";

if (true) {
  register("/service-worker.js", {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
      store.commit("pwa/setNewUpdateAvailable", true);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
      store.commit("pwa/setOffline", true);
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
